import React from 'react'
import '../styles/Preguntas.css'

const Preguntas = () => {
  return (
    <main className="preguntas-cont">
        

        <section className="preguntas-left">
        <h2>
Preguntas Frecuentes
        </h2>
        <h3>
             	
Panteones
        </h3>
        <div className="par">
        <p className="pregunta">
        ¿A quién debo llamar en el caso del fallecimiento de un socio?
       </p>
       <p className="respuesta">
       Al 0800-666-5566 durante las 24 hs, los 365 días de año.
       </p>
       </div>
      
     <div className="par">
       <p className="pregunta">
       ¿Cuántos años puede estar un resto en el Panteón?
       </p>
       <p className="respuesta">
       Si es ataúd el plazo máximo son 20 años. Los nichos se renuevan por el plazo que corresponda a cada caso, y se abona el arancel estipulado de acuerdo al permiso.
       </p>
    <p className="respuesta">
       Si los restos son en cenizas no tienen vencimiento, siempre y cuando estén a cargo de un asociado ó familiar que los represente?
       </p>
       </div>
       
       <div className="par">

       <p className="pregunta">
       ¿Tengo que abonar algo por la permanencia de los restos en los Panteones?
       </p>
       <p className="respuesta">
       Si, mientras los restos estén ocupando un nicho en el Panteón se abona una cuota mensual por permanencia
       </p>
       </div>
         <div className="par">
       <p className="pregunta">
       ¿Qué pasa con los restos a cargo de un socio cuando este fallece?
       </p>
       <p className="respuesta">
       Cuando se le da la baja como socio, los restos pasan a cargo del familiar más cercano, el cual quedará como nuevo responsable de los mismos. De no existir familiares quedarán como restos abandonados y pasarán a disposición de la Dirección General de Cementerios.
       </p>
         </div>
       <h3>
       Asociados
       </h3>
       <h5>
       Actualización de datos personales
       </h5>
       <p className="solo">
       Este procedimiento tiene como fin revisar, actualizar, modificar o suprimir información de la base de datos de la Mutual.
El trámite es muy sencillo: Acceda desde acá al FORMULARIO, imprímalo, cumpliméntelo y hágalo llegar a nuestras oficinas.
Esto nos permitirá mantener un fluido contacto con los asociados y enterarlos sobre noticias e información institucional y acerca de actividades que se organicen.
       </p>
       <div className="par">
       <p className="pregunta">
       ¿Por qué no se toman los cambios de domicilio telefónicamente?
       </p>
       <p className="respuesta">
       Por estrictas razones de seguridad. Al requerir del asociado una comunicación personal, postal o faxeada, se evitan posibles interferencias de terceros.
       </p>
         </div>
         <div className="par">
       <p className="pregunta">
       ¿Por qué no se remiten las actualizaciones de credenciales por correo?
       </p>
       <p className="respuesta">
       Dejar en manos del asociado la renovación de su credencial, fomenta un acercamiento de su parte a la Institución que pertenece. Es una manera sutil de integrarlo y brindarle la oportunidad de comprobar en cada visita a esta Mutual las mejoras que se van operando y la ocasión de presentarnos sugerencias.
       </p>
            </div>


            </section>
            <section className="preguntas-right">
                <div className="par">
                <p className="pregunta">
                Me trasladan al interior del país, ¿puedo acceder a una reducción en la cuota social?
                </p>
                <p className="respuesta">
                No, únicamente cuando el traslado se opere en situación de retiro y en forma permanente.
                </p>
                </div>
                <div className="par">
                <p className="pregunta">
                ¿Por qué una baja por renuncia no se hace efectiva a partir de la fecha de presentación de la misma?
                </p>
                <p className="respuesta">
                La cuota social se descuenta de los haberes del socio por mes adelantado. Es decir, que el mes en curso de la renuncia debe ser cubierto. Si la misma se produce en los últimos días del mes en curso, habiendo sido girados ya los cargos a el IAF, se le descontará el mes siguiente al de la presentación de la renuncia, pudiendo, en este caso, solicitar el reintegro en la oficina de Cargos de la Institución.
                </p>
                </div>

                <div className="par-dom">
                <p className="pregunta-dom">
                ¿Puedo asociar al personal doméstico?
                </p>
                <p className="respuesta-dom">
                Sí, puede hacerlo en la categoría de Adherente.
                </p>
                </div>

                <h4>
                Subsidio por fallecimiento. Servicio de sepelio.
                </h4>
                <div className="par">
                <p className="pregunta">
                ¿Qué diferencia hay entre un seguro y un subsidio?
                </p>
                <p className="respuesta">
                El seguro implica una obligación contractual de la que surgen limitaciones específicas (montos, edades, etc.) El subsidio es una ayuda que la Mutual brinda a sus asociados, por un monto determinado y puede acceder a él cualquier socio independientemente de la edad que tenga.
                </p>
                </div>
                <div className="par">
                <p className="pregunta">
                ¿Qué documentación hay que presentar para la apertura del sobre de beneficiarios del asociado fallecido?
                </p>
                <p className="respuesta">
                La apertura del sobre de la declaración de beneficiarios se produce con la presentación de la Partida de Defunción emitida por el Registro Civil (original y copia) y el documento de identidad de la persona que la presenta.
                </p>
                </div>
                <div className="par">
                <p className="pregunta">
                ¿Por qué no puedo renunciar al Servicio de Sepelio?
                </p>
                <p className="respuesta">
                El servicio de sepelio es una de las prestaciones que brinda la Asociación, forma parte del cúmulo de beneficios que se le otorgan al asociado y es indivisible, forma parte de un todo, no es selectivo.
                </p>
                </div>
                </section>
        
        
        
        </main>
  )
}

export default Preguntas